// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

import {
  defineRepositoryItemId,
  type RepositoryItemId,
  type RepositoryItemIdString
} from 'cadenza/repository/model/repository-item-id';

/** @see net/disy/cadenza/repository/api/project/ProjectId.java */
export type ProjectId = RepositoryItemId<'PROJECT'>;
/** @see net/disy/cadenza/repository/api/project/ProjectId.java */
export const ProjectId = defineRepositoryItemId('PROJECT');
/**
 * @knipignore
 * @see net/disy/cadenza/repository/api/project/ProjectId.java
 */
export type ProjectIdString = RepositoryItemIdString<'PROJECT'>;

// </GENERATED-CODE>
